import React from 'react';
import {connect} from 'react-redux'
import {
  multiple_mark_read,
  // multiple_publish,
  // multiple_unpublish
} from '../actions'

const mapStateToProps = state => {
  return {

  }
}

const mapDispatchToProps = dispatch => {
  return {
    MarkRead: (report_id, entry_ids) => dispatch( multiple_mark_read( report_id, entry_ids) ),
  }
}

class ConnectedToolbar extends React.Component {
  constructor() {
    super()
    this.state = {
      selector: null,
      disabled: "disabled",
      action: ""
    }
  }

  componentDidMount() {
    const el = document.getElementById('selected_action_select')
    const selector = window.M.FormSelect.init(el)
    this.setState({selector: selector})
  }

  MarkRead = () => {
    const {report_id} = this.props
    const entry_ids = this.props.selectedRows.map((row) => row.id)
    this.props.MarkRead(report_id, entry_ids)
  };

  handleChange = e => {
      const action = e.target.value;
      if (action === "") {
        this.setState({disabled: "disabled", action: ""})
      } else {
        this.setState({disabled: "", action: action})
      }
  }

  commitAction = e => {
    const {action} = this.state
    switch (action) {
      case "mark_read": {
        return this.MarkRead()
      }
      default: {
        return null
      }
    }
  }

  render() {
    const {visible, totalRows, fetchedRows, selectedRows} = this.props

    const toolbarClass = (visible) ? "col s12 l6 xl6 flex flex-right" : "hide"

    return (
      <div className="grid-toolbar">
        <div className="row">
          <div className="col s12 l4 xl4 rowset-info">
            <div className="col s4 l4 xl4">{totalRows} Rows, </div>
            <div className="col s4 l4 xl4">{fetchedRows || 0} fetched, </div>
            <div className="col s4 l4 xl4">{selectedRows.length || 0} selected</div>
          </div>
          <div className={toolbarClass}>
            <div className="col s12 l10 xl10">
              <select id="selected_action_select" onChange={ e => {
                this.handleChange(e)
              }}>
                <option value="">Action for selected items...</option>
                <option value="mark_read">Mark Items as Viewed</option>
              </select>
            </div>
            <div className="col s12 l2 xl2">
              <button className="btn btn-small waves-effect waves-light actionsButton" disabled={this.state.disabled} onClick={ e => {
                this.commitAction(e)
              }}>Go</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const Toolbar = connect(mapStateToProps, mapDispatchToProps)(ConnectedToolbar)

export default Toolbar



// WEBPACK FOOTER //
// ./src/js/components/Toolbar.js